const Types = {
  FEES_BETWEEN_ZONES_LOADING: "FEES_BETWEEN_ZONES_LOADING",
  GET_BETWEEN_ZONES_FEES_SUCCESS: "GET_BETWEEN_ZONES_FEES_SUCCESS",
  GET_BETWEEN_ZONES_FEE_DETAILS_SUCCESS: "GET_BETWEEN_ZONES_FEE_DETAILS_SUCCESS",
};

export default Types;
